import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CommonDate, DatePickerComponent, FuzzyDate } from '@hs/ui-core-date';
import { OptionToggleComponent } from '@hs/ui-core-inputs';

@Component({
    selector: 'ddv-active-date-form',
    templateUrl: './active-date-form.component.html',
    styleUrls: ['./active-date-form.component.scss'],
    imports: [
        OptionToggleComponent,
        DatePickerComponent,
    ],
})
export class ActiveDateFormComponent implements OnChanges {
    @Input() mode: 'active-date' | 'date-range' = 'date-range';
    @Input() activeDate: CommonDate | FuzzyDate | undefined;
    @Input() fuzzyDates: FuzzyDate[] = [];
    @Input() minDate: CommonDate | undefined;
    @Input() maxDate: CommonDate | undefined;

    @Output() modeChange = new EventEmitter<'active-date' | 'date-range'>();
    @Output() activeDateChange = new EventEmitter<CommonDate | FuzzyDate | undefined>();

    protected useFullDateRange = true;

    ngOnChanges(): void {
        this.useFullDateRange = this.mode === 'date-range';
    }

    protected onActiveDateChanged(): void {
        if (this.useFullDateRange) {
            return;
        }

        this.activeDateChange.emit(this.activeDate);
    }
}
